import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
    position: fixed;
    inset: 0;
    z-index: 200;
    background-color: rgba(0, 0, 0, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1em;

    .wrapper-public-placeholder-cover {
        &__info-container {
            background-color: ${vars.colorPrimaryWhite};
            width: 100%;
            max-width: 600px;
            height: 100%;
            max-height: 200px;
            border-radius: 0.6em;
            overflow: hidden;
            box-shadow: 4px 4px 0 #0a8b0a, 8px 8px 0 #12b012, 12px 12px 0 #11d011;

            &__logo {
                background-color: ${vars.colorSecondaryDark};
            }

            &__title {
                padding: 2em 0 1em;
                text-align: center;
                font-size: 1.3em;
                font-weight: 500;
            }

            &__subtitle {
                padding: 1em;
                text-align: center;
                font-size: 1em;
                font-weight: 400;
            }
        }
    }
`;
